var _defs, _g, _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPhonemw(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Camada_1",
    "data-name": "Camada 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 213.1 429.6",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#5e465d;}.cls-2{fill:#706f6f;}.cls-3{fill:#1d1d1b;}.cls-4{fill:#5b2e87;}.cls-5{fill:url(#Gradiente_sem_nome);}.cls-6{fill:url(#Gradiente_sem_nome_2);}.cls-7{fill:url(#Gradiente_sem_nome_3);}.cls-8{fill:url(#Gradiente_sem_nome_4);}.cls-9{fill:url(#Gradiente_sem_nome_5);}.cls-10{fill:url(#Gradiente_sem_nome_6);}.cls-11{fill:url(#Gradiente_sem_nome_7);}.cls-12{fill:url(#Gradiente_sem_nome_8);}.cls-13{fill:url(#Gradiente_sem_nome_9);}.cls-14{fill:url(#Gradiente_sem_nome_10);}.cls-15{fill:url(#Gradiente_sem_nome_11);}.cls-16{fill:url(#Gradiente_sem_nome_12);}.cls-17{isolation:isolate;}.cls-18{fill:url(#Gradiente_sem_nome_13);}.cls-19{fill:url(#Gradiente_sem_nome_14);}.cls-20{fill:url(#Gradiente_sem_nome_15);}.cls-21{fill:url(#Gradiente_sem_nome_16);}.cls-22{fill:#fff;}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Gradiente_sem_nome",
    x1: -1098.9,
    y1: -624.51,
    x2: -1047.1,
    y2: -624.51,
    gradientTransform: "translate(-412.61 1208.7) rotate(90)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#68595f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#896e80"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#5e3b5b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#2b1d2a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#704a6a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#615060"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#2b1d2a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#5e3b5b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#845675"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5b4a5c"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Gradiente_sem_nome_2",
    x1: -1098.92,
    y1: -625.41,
    x2: -1047.12,
    y2: -625.41,
    gradientTransform: "translate(-377.91 1208.7) rotate(90)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#676067"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#654e63"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#786f77"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#786f77"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#654e63"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#676067"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Gradiente_sem_nome_3",
    x1: -1109.8,
    y1: 1994.19,
    x2: -1077,
    y2: 1994.19,
    gradientTransform: "matrix(0, 1, 1, 0, -1993.44, 1208.7)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#68595f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#896e80"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#5e3b5b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#2d1e2c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#704a6a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#615060"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#2d1e2c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#5e3b5b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#845675"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5b4a5c"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Gradiente_sem_nome_4",
    x1: -1109.8,
    y1: 1993.64,
    x2: -1077,
    y2: 1993.64,
    gradientTransform: "matrix(0, 1, 1, 0, -1958.74, 1208.7)",
    xlinkHref: "#Gradiente_sem_nome_2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Gradiente_sem_nome_5",
    x1: 36.2,
    y1: 439.7,
    x2: 36.2,
    y2: 406.9,
    gradientTransform: "translate(-34.7 -308)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#68595f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#2d1e2c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#5e3b5b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#2d1e2c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5b4a5c"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Gradiente_sem_nome_6",
    x1: -1068.6,
    y1: 1994.19,
    x2: -1035.8,
    y2: 1994.19,
    xlinkHref: "#Gradiente_sem_nome_3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Gradiente_sem_nome_7",
    x1: -1068.56,
    y1: 1993.64,
    x2: -1035.76,
    y2: 1993.64,
    gradientTransform: "matrix(0, 1, 1, 0, -1958.74, 1208.7)",
    xlinkHref: "#Gradiente_sem_nome_2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Gradiente_sem_nome_8",
    x1: 36.2,
    y1: 480.94,
    x2: 36.2,
    y2: 448.14,
    xlinkHref: "#Gradiente_sem_nome_5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Gradiente_sem_nome_9",
    x1: -1140.82,
    y1: 1994.19,
    x2: -1123.98,
    y2: 1994.19,
    xlinkHref: "#Gradiente_sem_nome_3"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Gradiente_sem_nome_10",
    x1: -1140.8,
    y1: 1993.64,
    x2: -1123.97,
    y2: 1993.64,
    gradientTransform: "matrix(0, 1, 1, 0, -1958.74, 1208.7)",
    xlinkHref: "#Gradiente_sem_nome_2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Gradiente_sem_nome_11",
    x1: 36.2,
    y1: 392.72,
    x2: 36.2,
    y2: 375.88,
    xlinkHref: "#Gradiente_sem_nome_5"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Gradiente_sem_nome_12",
    x1: 155.2,
    y1: 334.03,
    x2: 155.2,
    y2: 328.17,
    gradientTransform: "translate(-34.7 -308)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#666"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#010104"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Gradiente_sem_nome_13",
    x1: -1902.58,
    y1: -637.43,
    x2: -1902.58,
    y2: -640.78,
    gradientTransform: "translate(-1782.08 -615.79) rotate(180)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#0b131c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#354039"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Gradiente_sem_nome_14",
    x1: 265.9,
    y1: 366.89,
    x2: 263.8,
    y2: 364.78,
    gradientTransform: "translate(-109.64 -342.6)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#231f20"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#222326"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#1f2c37"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#1a3d54"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#13537c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#0b71ae"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#0094ec"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#0095ee"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#0488d6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#0d689f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.88,
    stopColor: "#154e72"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#1b394e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#1f2b35"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#222225"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231f20"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "Gradiente_sem_nome_15",
    cx: 264.84,
    cy: 365.84,
    r: 1.49,
    gradientTransform: "translate(-109.64 -342.6)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#231f20"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#175168"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#0d78a2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#0695cb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#02a7e5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#00adee"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#02a6e4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#0693c8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#0e749c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#184a5f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#231f20"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "Gradiente_sem_nome_16",
    cx: 265.66,
    cy: 366.62,
    r: 0.53,
    gradientTransform: "translate(-109.64 -342.6)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ccc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#c4c4c4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#898989"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#585858"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#323232"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#161616"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#060606"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "phonemw") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M70.1,0H212.4A33.61,33.61,0,0,1,246,33.6V396a33.61,33.61,0,0,1-33.6,33.6H70.1A33.61,33.61,0,0,1,36.5,396V33.6A33.67,33.67,0,0,1,70.1,0Z",
    transform: "translate(-34.7)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M212.1,1H70.4A32.84,32.84,0,0,0,37.5,33.8h0V395.7a32.82,32.82,0,0,0,32.8,32.8H212.1a32.82,32.82,0,0,0,32.8-32.8V33.8A32.69,32.69,0,0,0,212.1,1ZM244,395.5a32.14,32.14,0,0,1-32.1,32.1H70.7a32.14,32.14,0,0,1-32.1-32.1V34.1A32.07,32.07,0,0,1,70.7,2H211.9A32.14,32.14,0,0,1,244,34.1h0Z",
    transform: "translate(-34.7)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M71,3.3H211.6a30.92,30.92,0,0,1,30.9,30.9V395.5a30.92,30.92,0,0,1-30.9,30.9H71a30.92,30.92,0,0,1-30.9-30.9V34.2A30.86,30.86,0,0,1,71,3.3Z",
    transform: "translate(-34.7)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M195.4,10.1h16.4a24.09,24.09,0,0,1,24.1,24V395.3a24,24,0,0,1-24.1,24H70.8a24.09,24.09,0,0,1-24.1-24V34.2a24,24,0,0,1,24.1-24H195.4Z",
    transform: "translate(-34.7)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 211.3,
    y: 109.8,
    width: 1.2,
    height: 51.8
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M247.2,161.5V109.7l.6.7c-.3,5.5-.3,44.9,0,50.4Z",
    transform: "translate(-34.7)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 0.4,
    y: 98.9,
    width: 0.7,
    height: 32.8
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M35.1,131.7V98.9l-.4.4c.2,3.5.2,28.5,0,32Z",
    transform: "translate(-34.7)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-9",
    x: 1.1,
    y: 98.9,
    width: 0.8,
    height: 32.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 0.4,
    y: 140.1,
    width: 0.7,
    height: 32.8
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M35.1,172.9V140.1l-.4.4c.2,3.5.2,28.5,0,31.9Z",
    transform: "translate(-34.7)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 1.1,
    y: 140.1,
    width: 0.8,
    height: 32.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-13",
    x: 0.4,
    y: 67.9,
    width: 0.7,
    height: 16.8
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M35.1,84.7V67.9l-.4.4c.2,3.3.2,12.7,0,16Z",
    transform: "translate(-34.7)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-15",
    x: 1.1,
    y: 67.9,
    width: 0.8,
    height: 16.8
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M157.1,30.1H123.6a6.74,6.74,0,0,1-6.8-6.8h0a6.74,6.74,0,0,1,6.8-6.8h33.5a6.74,6.74,0,0,1,6.8,6.8h0a6.87,6.87,0,0,1-6.8,6.8Z",
    transform: "translate(-34.7)"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-16",
    cx: 120.5,
    cy: 23.2,
    r: 3
  }), /*#__PURE__*/React.createElement("image", {
    className: "cls-17",
    width: 6,
    height: 6,
    transform: "translate(117.66 20.4)",
    xlinkHref: "631E490D.png"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-18",
    cx: 120.5,
    cy: 23.2,
    r: 1.7
  }), /*#__PURE__*/React.createElement("g", {
    id: "Camera"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M156.7,23.2a1.5,1.5,0,1,1-1.5-1.5h0A1.61,1.61,0,0,1,156.7,23.2Z",
    transform: "translate(-34.7)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M156.7,23.2a1.5,1.5,0,1,1-1.5-1.5h0A1.61,1.61,0,0,1,156.7,23.2Z",
    transform: "translate(-34.7)"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M156.6,24a.5.5,0,1,0-.5.5.47.47,0,0,0,.5-.5Z",
    transform: "translate(-34.7)"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M86.48,214.89c-4.09,7.85-9.09,17.54-11.15,21.51l-3.73,7.21h31.71l3.6-6.54c2.48-4.54,3.63-6.42,3.82-6.12s1.73,3.15,3.54,6.51l3.24,6.15h16c15.11,0,16,0,15.69-.55-.15-.27-3.91-7.48-8.36-16s-9.42-17.93-11-21l-2.91-5.54h-8l-1.33,2.48c-.76,1.39-2.09,3.94-3,5.69L112.92,212l1.82,3.39a33.46,33.46,0,0,0,2,3.39c.09,0,1.51-2.45,3.15-5.42s3.12-5.66,3.33-5.94c.33-.45,1.36,1.33,7.91,13.81,4.12,7.91,7.78,14.81,8.09,15.33l.61,1h-19l-10-18.42-10-18.39-3.45-.09-3.48-.06Zm15.79,0c2.39,4.54,4.33,8.36,4.3,8.48s-1.82,3.39-3.91,7.24l-3.82,7H90.21a77.51,77.51,0,0,1-8.51-.24c.42-1.12,15.87-30.65,16-30.65S99.87,210.35,102.27,214.86Z",
    transform: "translate(-34.7)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M134,201.11c.15.3,3.91,7.48,8.36,16s9.42,17.93,11,21l2.91,5.51,4.06-.06,4-.09,2.91-5.57,2.91-5.6-1.82-3.42a26.87,26.87,0,0,0-1.94-3.42c-.09,0-1.67,2.73-3.48,6l-3.3,6-6.48-12.3c-3.54-6.78-7.21-13.72-8.12-15.45l-1.64-3.09h18.93l10,18.42,10,18.39,3.48.09,3.48.06,7.72-14.9c4.24-8.21,9.27-17.87,11.15-21.51l3.42-6.6H179.9l-3.57,6.51c-2,3.57-3.6,6.51-3.67,6.51s-1.64-2.94-3.54-6.51l-3.42-6.51h-16C134.59,200.59,133.74,200.62,134,201.11Zm67.52,5.81c-.42,1.12-15.87,30.62-16,30.62s-8.84-16-8.84-16.51c0-.18,1.73-3.48,3.85-7.36l3.88-7H193A66.94,66.94,0,0,1,201.53,206.92Z",
    transform: "translate(-34.7)"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhonemw);
export default __webpack_public_path__ + "static/media/phonemw.dfdce85862c99f86ad0a18c2b27ed3a9.svg";
export { ForwardRef as ReactComponent };